__webpack_require__.p = "/chatgptaidemo/";